export const MENU_VALUES = {
  default: 'default',
  deleteWorkspace: 'deleteWorkspace',
  manageUsers: 'manageUsers'
} as const;
